export default "__VITE_ASSET__Bhk9tLhE__"